import Content from './Content'
import './App.css'

function App() {
  return (
    <div className='App'>
      <nav>ExampleUser</nav>
      <Content />
    </div>
  )
}

export default App
